const castes = [
  'Vanjari',
  'Dhangar',
  'Mali',
  'Kunbi',
  'Maratha',
  'Teli',
  'Sutar',
  'Lohar',
  'Shimpi',
  'Nhavi',
  'Parit',
  'Koli',
  'Agri',
  'Bhandari',
  'Sonar',
  'Chambhar',
  'Matang',
  'Mahar',
  'Buddhist',
  'Lingayat',
  'Brahmin',
  'Other',
];

export default castes;
